import {
  EmailTemplateConfiguration,
  EmailTemplateConfigurationKeys,
  EmailTemplates,
  EmailTemplatesDetailsMap,
  EmailTemplatesModels,
} from '@ag-common-lib/public-api';

export function filterTemplatesByDataModel(
  model: EmailTemplatesModels | [],
  emailTemplates: EmailTemplateConfiguration[],
): EmailTemplateConfiguration[] {
  const modelsSet = new Set(Array.isArray(model) ? model : [model]);
  const results = emailTemplates?.filter(emailTemplateConfiguration => {
    const templateName = emailTemplateConfiguration?.[EmailTemplateConfigurationKeys.templateName];

    if (typeof templateName === 'string' && templateName.startsWith('dynamic:')) {
      return modelsSet.has(EmailTemplatesModels.registrant);
    }

    const templateDetails = EmailTemplatesDetailsMap.get(templateName as EmailTemplates);

    if (!templateDetails) {
      return false;
    }

    if (templateDetails?.model) {
      return modelsSet.has(templateDetails?.model);
    }

    return false;
  });

  return results;
}
